// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__yGF8z","load1":"Spinner_load1__H-36e"};